if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let sectionsToFetch = [
          ...this.cartNotification.getSectionsToRender().map((section) => section.id),
        ];
        if (this.cartDrawer) {
          sectionsToFetch = [
            ...sectionsToFetch,
            ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
          ];
        }

        const formData = new FormData(this.form);
        formData.append('sections', sectionsToFetch);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        // Post the data to the cart add endpoint
        const response = await fetch(`${routes.cart_add_url}`, config);

        // Let's check if the response is okidokey
        if (!response.ok) throw new Error('Network response was not ok');

        // Get json response
        const parsedState = await response.json();
        // Show the error message if the response is not ok because of the inventory quantity
        if (response.status == 422) {
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
          return;
        }

        if (this.cartDrawer) {
          this.cartDrawer.renderContents(parsedState);
        }

        // Trigger the interface follow up based on theme settings
        switch (submitButton.dataset.addToCartBehavior) {
          case 'open_cart_drawer':
            if (this.cartDrawer) {
              this.cartDrawer.open();
            } else if (!Shopify.designMode) {
              window.location.reload();
            }
            break;
          case 'show_cart_notification':
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderContents(parsedState);
            break;
        }

        // Let the chat bot know that the cart has been updated
        if ('Zowie' in window) {
          Zowie.updateCart();
        }
      } catch (error) {
        console.error(error);
      }

      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
